/**
 * Options for every Stripe Payment Element. Stripe pre-selects the billing
 * country from the device region (e.g. "Azerbaijan"), but payers are in the
 * US (SPO-1244).
 */
export const stripePaymentElementOptions = {
  defaultValues: { billingDetails: { address: { country: 'US' } } },
};
